import styled from "styled-components";

export const Wrapper = styled.div`
  height: 100vh;

  #player-root {
    height: 100%;
  }
`;
